// TODO - Перенести из AB или удалить после завершения эксперимента CD-38289
import { IAppState } from '../../../../../common/state';
import { connect } from 'react-redux';
import { IJsonQuery, IJsonQueryType } from '../../../../../repositories/common/json_query';
import { FOfferType, offerTypeFromJsonQuery } from '../../../../../utils/category';
import { makeNewbuildingSearch } from '../../../../state/ab/newbuildingSearch';
import { NewbuildingGkButtonComponent } from './NewbuildingGkButtonComponent';

export interface IExperiment {
  abGroup: number;
  name: string;
}

export interface INewbuildingGkButtonState {
  experiments: Array<IExperiment>;
  filters: {
    jsonQuery: IJsonQuery;
  };
}

export const isNewbuildingGkButtonExperiment = (state: INewbuildingGkButtonState) => {
  const EXPERIMENT_NAME = 'newbuilding-serp-filter-checkbox';
  const RIGHT_OFFER_TYPES = [4];
  let isRightOfferType = false;

  let dealType: IJsonQueryType;
  let offerType: FOfferType;

  const { experiments, filters } = state;

  const experiment = experiments.find(experiment => experiment.name === EXPERIMENT_NAME);
  const experimentGroup = experiment ? Number(experiment.abGroup) : 0;

  if (experimentGroup === 0) {
    return false;
  }

  const { jsonQuery } = filters;

  if (jsonQuery) {
    dealType = jsonQuery._type;
    offerType = offerTypeFromJsonQuery(filters.jsonQuery);
    if (dealType && dealType === 'flatsale' && offerType && RIGHT_OFFER_TYPES.includes(offerType)) {
      isRightOfferType = true;
    }
  }

  return isRightOfferType;
};

interface INewbuildingGkButtonStoreProps {
  showExperimentButton: boolean;
}

interface INewbuildingGkButtonDispatchProps {
  makeNewbuildingSearch(): void;
}

export const NewbuildingGkButton = connect<INewbuildingGkButtonStoreProps, INewbuildingGkButtonDispatchProps>(
  (state: IAppState) => {
    const showExperimentButton = isNewbuildingGkButtonExperiment(state);

    return {
      showExperimentButton,
    };
  },
  {
    makeNewbuildingSearch,
  },
)(NewbuildingGkButtonComponent);
